(() => {
  const CHAT_ANCHOR = '#chat-atc';
  const FALLBACK_URL = document.currentScript?.dataset.atcChatFallbackUrl || '';

  document.querySelectorAll(`a[href="${CHAT_ANCHOR}"]`).forEach((link) => {
    link.dataset.atcChatTrigger = 'true';
    if (FALLBACK_URL !== '') link.setAttribute('href', FALLBACK_URL);
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-atc-chat-trigger="true"]');

    if (!link) return;

    if (!window.Microsoft?.Omnichannel?.LiveChatWidget?.SDK?.startChat) return;

    event.preventDefault();
    window.Microsoft.Omnichannel.LiveChatWidget.SDK.startChat({ inNewWindow: false });
  });
})();
